export default __webpack_public_path__ + "static/media/sus1.642bb8ce.jpg";